export default __webpack_public_path__ + "static/media/olubukola.90d5c720.png";